/**
 * Decoder mínimo do protobuf MEXC (PushDataV3ApiWrapper.publicSpotKline, campo 308).
 * Evita dependência de protobufjs — só o que o IDI-Chart precisa.
 */

function readVarint(buf, offset) {
  let result = 0
  let shift = 0
  let i = offset
  while (i < buf.length) {
    const b = buf[i++]
    result += (b & 0x7f) * Math.pow(2, shift)
    if ((b & 0x80) === 0) return [result, i]
    shift += 7
    if (shift > 63) break
  }
  return [result, i]
}

function decodeKlineBody(view) {
  const decoder = new TextDecoder()
  const out = {}
  let i = 0

  while (i < view.length) {
    const [key, next] = readVarint(view, i)
    i = next
    const field = key >>> 3
    const wire = key & 7

    if (wire === 0) {
      const [n, after] = readVarint(view, i)
      i = after
      if (field === 2) out.windowStart = n
      else if (field === 9) out.windowEnd = n
    } else if (wire === 2) {
      const [len, after] = readVarint(view, i)
      i = after
      const str = decoder.decode(view.subarray(i, i + len))
      i += len
      if (field === 1) out.interval = str
      else if (field === 3) out.openingPrice = str
      else if (field === 4) out.closingPrice = str
      else if (field === 5) out.highestPrice = str
      else if (field === 6) out.lowestPrice = str
    } else if (wire === 1) {
      i += 8
    } else if (wire === 5) {
      i += 4
    } else {
      return null
    }
  }

  const time = Number(out.windowStart)
  const open = parseFloat(out.openingPrice)
  const close = parseFloat(out.closingPrice)
  if (!time || !Number.isFinite(open) || !Number.isFinite(close)) return null

  const parsedHigh = parseFloat(out.highestPrice)
  const parsedLow = parseFloat(out.lowestPrice)
  const high = Number.isFinite(parsedHigh) ? parsedHigh : Math.max(open, close)
  const low = Number.isFinite(parsedLow) ? parsedLow : Math.min(open, close)

  return { time, open, high, low, close }
}

export function decodeMexcSpotKline(bytes) {
  const view = bytes instanceof Uint8Array ? bytes : new Uint8Array(bytes)
  let i = 0
  let klineBytes = null

  while (i < view.length) {
    const [key, next] = readVarint(view, i)
    i = next
    const field = key >>> 3
    const wire = key & 7

    if (wire === 0) {
      const [, after] = readVarint(view, i)
      i = after
    } else if (wire === 1) {
      i += 8
    } else if (wire === 5) {
      i += 4
    } else if (wire === 2) {
      const [len, after] = readVarint(view, i)
      i = after
      const slice = view.subarray(i, i + len)
      i += len
      if (field === 308) klineBytes = slice
    } else {
      return null
    }
  }

  if (!klineBytes) return null
  return decodeKlineBody(klineBytes)
}
